<template>
  <div>
    <Pane />
    <Allocate :visible="allocateVisible" :id="selectedProject.id" :ifRequest="false" :finList="finList" :incomeDeptSum="incomeDeptSum" :expendDeptSum="expendDeptSum" :allProgressList="allProgressList" :progressList="progressList" :allocateList="allocateList" :ifSync="ifSync" :allocateOver="allocateOver" :amount="amount" :finId="finId" :type="type" :filteredList1="progressList" :filteredList2="allocateList" @setVisible="allocateVisible=false" @success="saveSuccess"/>

    <a-card class="container">

      <div class="card-header">
        <div class="card-title">收支概况</div>
      </div>

      <a-descriptions bordered :column="2" size='small'>
        <a-descriptions-item>
          <div slot="label" class="center">项目名称</div>
          <div>
            <ProjectSelector @change="onSelectProject">
                <a-button
                    block
                    style="text-align: left;width: 100%"
                >{{ selectedProject.name ? selectedProject.name : '选择' }}</a-button>
              </ProjectSelector>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">责任部门</div>
          <div>
            <a-select
                show-search
                :filter-option="$selectFilterOption"
                v-model="detail.productionUnitId"
                style="width: 100%"
                placeholder=""
              >
                <a-select-option
                  v-for="item in productionDepartmentList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{
                  item.uniqueName }}
                </a-select-option>
              </a-select>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">经办人</div>
          <div>
              <EmployeeSelector @change="(arr) => {
                                if (arr.length > 0) {
                                selectedUser = arr[0];
                                } else {
                                selectedUser = {};
                                }
                            }
                            " :value="selectedUser.name ? [selectedUser] : []">
                <a-button block style="text-align: left;width: 100%">
                <div v-if="selectedUser.name">
                    {{ selectedUser.name }}
                </div>
                <div v-else>&nbsp;</div>
                </a-button>
            </EmployeeSelector>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">选择分包</div>
          <div>
            <a-select
              placeholder=""
              v-model="detail.subIds"
              style="width: 100%"
              @change="onSelectSubProject"
              mode="multiple"
            > 
              <a-select-option :value="item.id" v-for="item in subProjectList">{{ item.name }}</a-select-option>
            </a-select>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">分包公司</div>

          <div>
            <a-button block style="text-align: left;width: 100%" class="ellipsis">
              <div
                class="left text-hidden selected"
              >
                {{ selectedCompany.name }}
              </div>
            </a-button>
          </div>
          
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">发生金额(万)</div>
          <div>
            <a-input-number
                placeholder=""
                v-model="detail.amount"
                style="width: 100%"
                @change="handleAmountChange"
              />
          </div>
        </a-descriptions-item>

        <a-descriptions-item>
          <div slot="label" class="center">发生日期</div>
          <div>
            <a-date-picker
                v-model="detail.date"
                placeholder=""
                style="width: 100%"
              />
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">所属月份</div>
          <div>
            <a-month-picker
                format="YYYY-MM"
                v-model="detail.belongMonth"
                placeholder=""
                style="width: 100%"
              />
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">收支类型</div>
          <div>
            <a-select
              placeholder=""
              v-model="detail.type"
              style="width: 100%"
            > 
              <a-select-option value="income">收入</a-select-option>
              <a-select-option value="expend">支出</a-select-option>
            </a-select>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">是否扣除产值</div>
          <div>
            <a-select
              placeholder=""
              v-model="detail.isDeductOutputValue"
              style="width: 100%"
            > 
              <a-select-option value="必要">必要</a-select-option>
              <a-select-option value="非必要">非必要</a-select-option>
              <a-select-option value="收入">收入</a-select-option>
            </a-select>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">备注</div>
          <div>
            <a-textarea
                placeholder=""
                v-model="detail.remark"
                style="width: 100%"
              />
          </div>
        </a-descriptions-item>
      </a-descriptions>

      <div class="card-header">
        <div class="card-title">分配详情</div>
        <a-button type="primary" style="margin-left: 20px;" @click="allocate(detail)">分配</a-button>
      </div>
      <a-table bordered :data-source="detail.deptList" :loading="loading" :pagination="false">
        <a-table-column title="部门" data-index='deptName' />
        <a-table-column title="专业">
          <template slot-scope="text">
            <DataDictFinder dictType="majorTypes" :dictValue="text.deptMajor" />
          </template>
        </a-table-column>
        <a-table-column title="部门占比">
          <template slot-scope="text">
            {{ text.prop }}%
          </template>
        </a-table-column>
        <a-table-column title="金额(万元)">
          <template slot-scope="text">
            <Money :money="text.amount" />
          </template>
        </a-table-column>
      </a-table>
      <div class="center" style="margin-top: 40px;">
        <a-space>
          <a-button @click="$close($route.path)">关闭</a-button>
          <a-button type="primary" @click="handleSubmit">保存</a-button>
        </a-space>
      </div>
    </a-card>
  </div>
</template>



<script>

import request from '@/api/request'
import { fetchDetail as fetchDetailSub } from "@/api/project";
import Allocate from './components/allocate.vue'
import CompanySelector from "@/components/company-selector";
import ProjectSelector from "@/components/project-selector";
import EmployeeSelector from "@/components/employee-selector";
import organization from "@/mixins/organization";
function fetchDetail(id) {
  return request({
      url:  '/project-service/projectFin/detail2/' +id,
      method: 'post',
  })
}
function add(data) {
  return request({
      url:  '/project-service/projectFin/add',
      method: 'post',
      data,
  })
}

function remove(id) {
  return request({
      url:  '/project-service/projectFin/del/' +id,
      method: 'post',
  })
}

export default {

  name: 'projectFin_detail',
  mixins: [ organization],
  components:{
    Allocate,
    CompanySelector,
    ProjectSelector,
    EmployeeSelector
  },
  data() {
      return {
          subProjectList: [],
          selectedCompany: {}, // 选中的公司
          selectedUser: {},
          allocateVisible: false,
          visible: false,
          loading: false,
          detail: {
            deptList: [],
          },
          bidList: [],
          bidBudgetList: [],

          saveLoading: false,
          finList: [],
          incomeDeptSum: [],
          expendDeptSum: [],
          type: '',
          filteredList: [],
          allProgressList: [],
          progressList: [],
          allocateList: [],
          finId: '',
          amount: 0,
          allocateOver: 0,
          ifSync: false,
          selectedProject: {
            name: ''
          }
      }
  },

  computed: {
    
  },

  mounted() {
    //查询subProjectList
  },


  methods: {
    handleAmountChange(value) {
      this.detail.deptList.forEach(element => {
        element.amount = element.prop / 100 * value * 10000;
      });
    },
    onSelectSubProject(value) {
      this.selectedCompany.id = []
      this.selectedCompany.name = []
      console.log("value", value);
      value.forEach(v => {
        const pp = this.subProjectList.find(item => item.id === v)
        if(pp){
          this.selectedCompany.id && this.selectedCompany.id.push(pp.companyId)
          this.selectedCompany.name.push(pp.companyName)
        }
      });
      if(this.selectedCompany.id.length > 0){
        this.selectedCompany.id = this.selectedCompany.id.join(',')
        this.selectedCompany.name = this.selectedCompany.name.join(',')
      }else{
        this.selectedCompany.id = ''
        this.selectedCompany.name = ''
      }
      
    },
    onSelectProject(value) {
      console.log("value", value);
      this.selectedProject.name = value.name;
      this.selectedProject.id = value.id;
      fetchDetailSub(value).then(res => {
        if (res) {
          this.subProjectList = res.subPackages;
        }
      })
    },
    getList(){
      const { id } = this.$route.query;
      this.loading = true;
      fetchDetail(id).then(res => {
        if (res) {
          this.detail = res;
          this.finList = res.finList || []
          this.incomeDeptSum = res.incomeDeptSum || []
          this.expendDeptSum = res.expendDeptSum || []
          this.allProgressList = res.projectProgressList;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    leiJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i && item.type == 'income') {
          amount += item.amount;
        }
      });
      return amount
    },
    leiJiYuJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i) {
          amount += (this.detail.subSum / this.detail.projectAmount * item.amount);
        }
      });
      return amount.toFixed(6)
    },
    leiJiShiJiAmount(i) {
      let amount = 0;
      this.finList.forEach((item, index) => {
        if(index <= i && item.type == 'expend') {
          amount += item.amount;
        }
      });
      return amount
    },
    addIncome() {
      this.visible = true;
      this.type = 'income';
      this.filteredList = [];
    },
    addExpend() {
      this.visible = true;
      this.type = 'expend';
      this.filteredList = [];
    },
    handleAdd() {
        const newData = {
          editable: true,
          belongMonth: null,
          date: null,
          amount: null
        };
        this.filteredList.push(newData)
      },
    handleSave(text, index) {
      this.filteredList.splice(index, 1, {
        belongMonth: text.belongMonth ? text.belongMonth.format("YYYY-MM") : null,
        date: text.date ? text.date.format("YYYY-MM-DD") : null,
        amount: text.amount,
        editable: false
      })
    },  
    handleDelete(text,index) {
      this.filteredList.splice(index, 1)
    },
    handleSubmit() {
      if(!this.selectedProject.id){
        this.$message.error('请选择项目');
        return;
      }
      let total = 0;
      this.detail.deptList.forEach(v=>{
          total = total + parseFloat(v.prop);
      })
      if(this.detail.deptList.length && parseInt(total.toFixed())!=100){
          this.$message.error("部门占比总和必须为100%");
          return;
      }
      const json = {
        ...this.detail,
        amount: this.detail.amount * 10000,
        handlerUserId: this.selectedUser.id,
        handlerUserName: this.selectedUser.name,
        projectId: this.selectedProject.id,
        companyId: this.selectedCompany.id,
        companyName: this.selectedCompany.name,
        subIds: this.detail.subIds?this.detail.subIds.join(','):'',
        date: this.detail.date ? this.detail.date.format("YYYY-MM-DD") : null,
        belongMonth: this.detail.belongMonth ? this.detail.belongMonth.format("YYYY-MM") : null,
        productionUnitName: this.productionDepartmentList.find(item => item.id === this.detail.productionUnitId).uniqueName,
      }
      add(json).then(()=>{
        console.log(111)
        this.visible = false;
        this.$close(this.$route.path);
      })
    },
    allocate(row){
      if(!this.detail.amount){
        this.$message.error('请先填写发生金额');
        return;
      }
      this.allocateVisible = true;
      this.type = row.type;
      this.finId = row.id;
      this.amount = row.amount;
      this.allocateOver = row.allocateOver;
      this.allocateList = JSON.parse(JSON.stringify(row.deptList));
      this.ifSync= row.ifSync ? true:false;
    },
    removeA(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove(text.id).then(() => {
            that.getList();
          });
        }
      });
    },
    saveSuccess(value) {
      this.allocateVisible = false;
      this.detail.deptList = value;
    }
  }
}
</script>

<style lang="less" scoped>
.container {
background-color: #fff;
padding: 24px 160px;
}

.card-header {
margin-top: 16px;
margin-bottom: 8px;
display: flex;
align-items: center;
justify-content: space-between;

.card-title {
font-weight: bold;
font-size: 14px;
color: #1890ff;
}


}
.sub-header{
  margin: 20px 5px 5px 5px;
}
</style>